import { useQuery } from '@apollo/client'
import type { WatchQueryFetchPolicy } from '@apollo/client'

import {
  privateProfileQuery,
  profileQuery,
  publicProfileProgressionQuery,
  publicProfileQuery,
  publicProfileSteamQuery
} from 'src/graphql'
import type {
  PrivateProfileQuery,
  PrivateProfileQueryVariables,
  ProfileQuery,
  ProfileQueryVariables,
  PublicProfileProgressionQuery,
  PublicProfileProgressionQueryVariables,
  PublicProfileQuery,
  PublicProfileQueryVariables,
  PublicProfileSteamQuery,
  PublicProfileSteamQueryVariables
} from 'src/graphql/types'

export function useProfile(
  fetchPolicy: WatchQueryFetchPolicy,
  pollInterval?: number
) {
  const { data, loading, error } = useQuery<
    ProfileQuery,
    ProfileQueryVariables
  >(profileQuery, {
    fetchPolicy,
    pollInterval
  })
  return { loading, error, profile: data?.profile }
}

export function usePrivateProfile() {
  const { data, loading, error, refetch } = useQuery<
    PrivateProfileQuery,
    PrivateProfileQueryVariables
  >(privateProfileQuery, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    errorPolicy: 'all'
  })
  return { data, loading, error, refetch }
}

export function usePublicProfile(
  profileId: string,
  fetchPolicy: WatchQueryFetchPolicy = 'cache-and-network'
) {
  const { data, loading, error, refetch } = useQuery<
    PublicProfileQuery,
    PublicProfileQueryVariables
  >(publicProfileQuery, {
    variables: { profileId },
    fetchPolicy,
    nextFetchPolicy: 'cache-first',
    errorPolicy: 'all'
  })
  return { data, loading, error, refetch }
}

export function usePublicProfileSteam(
  profileId: string,
  fetchPolicy: WatchQueryFetchPolicy = 'cache-and-network'
) {
  const { data, loading, error, refetch } = useQuery<
    PublicProfileSteamQuery,
    PublicProfileSteamQueryVariables
  >(publicProfileSteamQuery, {
    variables: { profileId },
    fetchPolicy,
    nextFetchPolicy: 'cache-first',
    errorPolicy: 'all'
  })
  return { data, loading, error, refetch }
}

export function usePublicProfileProgression(
  profileId: string,
  fetchPolicy: WatchQueryFetchPolicy = 'cache-and-network'
) {
  const { data, loading, error, refetch } = useQuery<
    PublicProfileProgressionQuery,
    PublicProfileProgressionQueryVariables
  >(publicProfileProgressionQuery, {
    variables: { profileId },
    fetchPolicy,
    nextFetchPolicy: 'cache-first',
    errorPolicy: 'all'
  })
  return { data, loading, error, refetch }
}
